import { replaceReducer, appendReducer } from "./products.mjs";
import { mapProductListing } from "./mapper.mjs";
import { extractValue } from "../../utils/collections.mjs";
import {
  TypedDocumentString
} from "../../graphql/Auth.mjs";
import { useQuery } from "villus";
import { ref, computed, watch } from "vue";
export function useExtendableProductsGeneric(productsDocument, mapperFn, variables) {
  const query = new TypedDocumentString(
    productsDocument
  );
  const products = ref([]);
  const totalCount = ref(0);
  const variablesInput = computed(() => {
    const realValues = extractValue(variables);
    return realValues;
  });
  const { data, error, isFetching } = useQuery({
    query: query.toString(),
    variables: variablesInput
  });
  watch(data, (value) => {
    const fetchedPage = data.value?.connection?.page_info?.current_page;
    const reducer = fetchedPage === 1 || !fetchedPage ? replaceReducer : appendReducer;
    products.value = reducer(
      products.value,
      value?.connection?.nodes?.filter((node) => !!node)?.map(
        (node) => ({
          ...mapProductListing(node),
          ...mapperFn ? mapperFn(node) : {}
        })
      ) ?? []
    );
    totalCount.value = value?.connection?.total_count || 0;
  });
  return {
    products,
    totalCount,
    data,
    error,
    isFetching
  };
}
export const ExtendedProductDocument = (document, field, value) => {
  const extendedProductDocument = document.toString()?.replace(
    new RegExp(`${field}\\s*{\\s*([^}]*)\\s*}`, "gm"),
    `${field}${value}`
  );
  return extendedProductDocument;
};
